import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { apiService } from '../../services/api';
import { getServerData } from '../../utils/catalogUrls';
import CursoDetalhe from '../meuscursos/CursoDetalhe';
import Cursos from '../Cursos';
import CatalogoNaoEncontrado from './CatalogoNaoEncontrado';

const matchesSlug = (slug) => (data) => (
  (data.type === 'curso' && data.curso?.slug === slug)
  || (data.type === 'categoria' && data.categoria?.slug === slug)
);

// /cursos/:slug atende cursos e categorias, que compartilham o mesmo namespace.
const CatalogoSlug = () => {
  const { slug } = useParams();
  const [state, setState] = useState(() => ({ slug, data: getServerData(matchesSlug(slug)) }));

  useEffect(() => {
    if (state.slug === slug && state.data) return undefined;

    let active = true;
    setState({ slug, data: null });
    apiService.cursos.resolveSlug(slug)
      .then((response) => {
        if (active) setState({ slug, data: response.data });
      })
      .catch(() => {
        if (active) setState({ slug, data: { type: 'not_found' } });
      });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const data = state.slug === slug ? state.data : null;

  if (!data) {
    return <div className="seo-page">Carregando...</div>;
  }

  switch (data.type) {
    case 'redirect':
      return <Navigate to={data.url} replace />;
    case 'curso':
      return <CursoDetalhe key={data.curso.id} curso={data.curso} />;
    case 'categoria':
      return <Cursos categoria={data.categoria} />;
    default:
      return <CatalogoNaoEncontrado />;
  }
};

export default CatalogoSlug;
